import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CreateAccountingSessionReq from "../../../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import MDInput from "components/MDInput";
import AsyncSelect from "react-select/async";
import UsersApi from "../../../../../Classes/API/UsersApi";
import searchUsersReq from "../../../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../../../Classes/Models/Requests/Users/UserTypes";

const SearchSingleSessions = ({ setSearchReq, GetTableData, IsLoaded }) => {
  const [Id, setId] = useState();
  const [IsPaidFor, setIsPaidFor] = useState();
  const [IsException, setIsException] = useState();
  const [NoAppointmentOnly, setNoAppointmentOnly] = useState(true);
  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState({});
  const [SessionName, setSessionName] = useState();

  useEffect(async () => {
    //Get data
    if (!IsLoaded) {
      await GetTableData();
    }
  }, [IsLoaded]);
  const GetPatients = async () => {
    let searchReq = new searchUsersReq();
    let UserTypes1 = new UserTypes();
    searchReq.name = PatientsSearch;
    searchReq.userType = UserTypes1.Patient;
    searchReq.pagingParams.pageSize = 33;
    let res = await UsersApi.SearchUsers(searchReq);
    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.getPatient, label: item.name });
      });
      return optionsArr;
    }
  };
  const onSearch = async () => {
    await GetTableData();
  };
  useEffect(() => {
    let searchReq = new CreateAccountingSessionReq();
    searchReq.id = Id;
    searchReq.isPaidFor = IsPaidFor;
    searchReq.isException = IsException;
    searchReq.noAppointmentOnly = NoAppointmentOnly;
    searchReq.patientId = Patient.id;
    searchReq.sessionName = SessionName;
    searchReq.pagingParams.pageSize = 10;
    searchReq.isAbsent = false;
    setSearchReq(searchReq);
  }, [Id, IsPaidFor, Patient, SessionName, IsException, NoAppointmentOnly]);

  useEffect(() => {
    onSearch();
  }, []);
  return (
    <Card mb={3} className="mx-4 mt-3 p-3" sx={{ marginBottom: "2em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          Search
        </MDTypography>
      </MDBox>
      <div className="container-fluid">
        <div className="row align-items-end">
          <div className="col-md-4">
            <MDBox mb={1}>
              <MDTypography variant="button" fontWeight="regular" color="text">
                Patient
              </MDTypography>
            </MDBox>
            <AsyncSelect
              isClearable={true}
              loadOptions={GetPatients}
              onInputChange={setPatientsSearch}
              onChange={(e) => setPatient(e ? e.value : "")}
              className="react-select-container"
              classNamePrefix="react-select"
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "42px",
                }),
              }}
            />
          </div>
          <div className="col-md-4">
            <MDInput
              fullWidth
              onChange={(e) => setId(e.target.value)}
              label="Accounting Session Id"
              placeholder="Enter ID..."
              inputProps={{
                style: {
                  textAlign: "center", // Center text in MDInput
                  height: "20px", // Adjust height to match
                },
              }}
              sx={{
                "& .MuiInputBase-root": {
                  height: "42px",
                },
                "& .MuiInputLabel-root": {
                  transform: "translate(14px, 12px) scale(1)",
                },
                "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled": {
                  transform: "translate(14px, -9px) scale(0.75)",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "10.5px 14px",
                },
              }}
            />
          </div>

          <div className="col-md-4">
            <MDInput
              fullWidth
              type="text"
              onChange={(e) => setSessionName(e.target.value)}
              label="Session Name"
              inputProps={{
                style: {
                  textAlign: "center", // Center text in MDInput
                  height: "20px", // Adjust height to match
                },
              }}
              sx={{
                "& .MuiInputBase-root": {
                  height: "42px", // Explicit height to match AsyncSelect
                },
                "& .MuiInputLabel-root": {
                  transform: "translate(14px, 12px) scale(1)", // Adjust label position
                },
                "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiFormLabel-filled": {
                  transform: "translate(14px, -9px) scale(0.75)",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "10.5px 14px", // Adjust input padding
                },
              }}
            />
          </div>
          <div className="col-md-4 mt-3">
            <label>
              <input
                type="checkbox"
                className="mr-2"
                defaultChecked={IsPaidFor}
                onChange={() => setIsPaidFor(!IsPaidFor)}
              />
              Paid For
            </label>
          </div>
          <div className="col-md-4 mt-3 d-flex align-items-center">
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                className="mr-2"
                defaultChecked={IsException}
                onChange={() => setIsException(!IsException)}
              />
              Exception
            </label>
          </div>
          <div className="col-md-4 mt-3 d-flex align-items-center">
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                className="mr-2"
                defaultChecked={NoAppointmentOnly}
                onChange={() => setNoAppointmentOnly(!NoAppointmentOnly)}
              />
              No Appointments
            </label>
          </div>
        </div>
        <div className="col-md-12 text-right mt-3">
          <button
            style={{ backgroundColor: "#3560AD", borderColor: "#3560AD" }}
            type="button"
            className="btn btn-primary mt-2 float-right"
            onClick={() => onSearch()}
          >
            Search
          </button>
        </div>
      </div>
    </Card>
  );
};
export default SearchSingleSessions;
